var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[(_vm.currentDate === _vm.today)?_c('span',{staticClass:"mr-5"},[_vm._v("HOY")]):_vm._e(),_vm._v(_vm._s(_vm.currentDate))]),_c('ul',{staticClass:"ml-1"},_vm._l((_vm.todayActivities),function(activity,index){return _c('activity-list-item',{key:index,attrs:{"activity":activity}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }